import {
  ForwardedRef,
  ImgHTMLAttributes,
  forwardRef,
  useEffect,
  useState,
} from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoUri from '../../../assets/logo-home.svg';
import logoNetworkUri from '../../../assets/logo-network.svg';
import logoResourceUri from '../../../assets/logo-resources.svg';

function LogoHome(
  props: ImgHTMLAttributes<HTMLImageElement>,
  ref: ForwardedRef<HTMLImageElement>
) {
  const { pathname } = useLocation();
  const [logo, setLogo] = useState<string>(logoUri);
  const [visible, setVisible] = useState<boolean>(true);

  useEffect(() => {
    switch (pathname) {
      case '/':
        setLogo(logoUri);
        setVisible(true);
        break;
      case '/resources':
        setLogo(logoResourceUri);
        setVisible(true);

        break;
      case '/network':
        setLogo(logoNetworkUri);
        setVisible(true);

        break;
      case '/profile':
        setVisible(false);
        break;
      default:
        setVisible(false);
        break;
    }
  }, [pathname]);

  if (!visible) return <div></div>;

  return (
    <Link to={'/'}>
      <img src={logo} ref={ref} alt="Athleted Logo" {...props} />
    </Link>
  );
}

export default forwardRef(LogoHome);
